import { memo, useEffect,useMemo,useState } from 'react';
 import clsx from 'clsx';
import styles from './PosOverlay.module.scss';

export interface POSTransactionLine {
    posId: string;
    name: string;
    amount: number;
    cost: number;
}

export interface POSTransaction {
    _id: string;
    posId: string;
    posName: string;
    posCustomId: string;
    siteId: string;
    siteName: string;
    cameraId: string;
    goods: POSTransactionLine[];
    subtotal: number;
    total: number;
    tax: number;
    tag: string;
    isSuspicious: boolean;
    date: Date;
    thumbnail: string;
    startedAt: Date;
    posNativeId?: string;
    content: string[];
}

interface IBaseArgs {
    className?: string;
    small?: boolean;
    wallView?: boolean;
}
interface IItemArgs extends IBaseArgs {
    currentTransaction: POSTransaction;
}

export const PosOverlayItem = memo(({ currentTransaction, className, wallView, }: IItemArgs) => {
    const { content, posNativeId, posName } = currentTransaction;
    const [isHidden, setIsHidden] = useState(false);
    const name = posNativeId ?? posName;

    const title = useMemo(() => {
        if (!name) {
            return content.join('\n');
        }
        return [name, ...content].join('\n');
    }, [content, name]);

    useEffect(() => {
        const joinedContent = content.join(' ').toLowerCase();
        const shouldHide = joinedContent.includes('end sale') || joinedContent.includes('end transaction') || joinedContent.includes('end of transaction') || joinedContent.includes('end of sale') || joinedContent.includes('cancel sale') || joinedContent.includes('cancel transaction') || joinedContent.includes('cancel of transaction') || joinedContent.includes('cancel of sale') ||  joinedContent.includes('cancel') || joinedContent.includes('void sale') || joinedContent.includes('void transaction') || joinedContent.includes('void of transaction') || joinedContent.includes('void of sale') || joinedContent.includes('void') || joinedContent.includes('sale cancelled') || joinedContent.includes('transaction cancelled') || joinedContent.includes('sale voided') || joinedContent.includes('transaction voided') || joinedContent.includes('sale void') || joinedContent.includes('transaction void') || joinedContent.includes('sale voided') || joinedContent.includes('transaction finish')
        if (shouldHide) {
            const timer = setTimeout(() => setIsHidden(true), 15000);
            return () => clearTimeout(timer); 
        } else {
            setIsHidden(false); 
        }
    }, [content]);

    if (!content.length || isHidden) {
        return null;
    }
    return (
        <div
            className={clsx(styles.posContainer, className)}
            title={title}
        >
            {name && <span key={name} className={styles.bold}>{name}</span>}
            {content.map((line, i) => <span key={i}>{line}</span>)}
        </div>
    );
});

interface IOverlayArgs extends IBaseArgs {
    currentPOSTransactions: Record<string, POSTransaction>;
    archiveItem?: boolean;
}

const POS_OVERLAY_STYLES = [styles.topLeft, styles.topRight, styles.bottomLeft, styles.bottomRight];

export const PosOverlay = memo(({
    currentPOSTransactions,
    className,
    archiveItem = false,
    ...props
}: IOverlayArgs) => {
    //console.log("[PosOverlay RENDER] transactions:", currentPOSTransactions);
    return (
        <>
            {Object.entries(currentPOSTransactions||{}).map(
                ([_, transaction], index) => (
                    <PosOverlayItem
                        key={`${transaction._id}`}
                        currentTransaction={transaction}
                        className={clsx(POS_OVERLAY_STYLES[index], className, { [styles.archiveItem]: archiveItem && index === 0})}
                        {...props}
                    />
                ),
            )}
        </>
    );
});